import agreementActionTypes from "../actions/agreementActionTypes";
import { reducerFactory } from "../../common/redux/reducers/reducerFactory";

export const agreementReducer = reducerFactory.readReducer(agreementActionTypes);
